import {
  createSlice, PayloadAction
} from '@reduxjs/toolkit';
import { getLayers, getMapSettings, Layer, MapSettings } from '../../api/mapSettingsApi';
import { AppThunk } from '../../app/store';

export interface BaseState {
  mapSettings?: MapSettings;
  layers?: Layer[];
}

const initialState: BaseState = {};

export const mapSettings = createSlice({
  name: 'mapSettings',
  initialState,
  reducers: {
    setMapSettings: (state, action: PayloadAction<MapSettings>) => {
      state.mapSettings = action.payload;
    },
    setLayers: (state, action: PayloadAction<Layer[]>) => {
      state.layers = action.payload;
    }
  }
});

export const {
  setMapSettings,
  setLayers
} = mapSettings.actions;

export const fetchMapSettings = (): AppThunk => async dispatch => {
  try {
    const result = await getMapSettings();
    dispatch(setMapSettings(result));
  }
  catch (err: any) {
    console.log(err.toString());
  }
};

export const fetchLayers = (): AppThunk => async dispatch => {
  try {
    const result = await getLayers();
    dispatch(setLayers(result));
  }
  catch (err: any) {
    console.log(err.toString());
  }
};

export default mapSettings.reducer;
